<template>
    <div>
        <!--        <div v-if="isPhone" class="mobile">-->
        <!--            <div><img src="../../assets/img/bigDataHeader.png" alt=""></div>-->

        <!--            <div class="paid">-->
        <!--                <div><img src="../../assets/img/大数据mobile1.jpg" alt=""></div>-->
        <!--                <div><img src="../../assets/img/大数据mobile2.jpg" alt=""></div>-->
        <!--                <div><img src="../../assets/img/大数据mobile3.jpg" alt=""></div>-->
        <!--            </div>-->

        <!--            <div class="phone">-->
        <!--                <div><img src="../../assets/img/大数据phone1.jpg" alt=""></div>-->
        <!--            </div>-->

        <!--            <course-direction-pay class="<course-direction-pay-phone" :directionId='directionId'/>-->
        <!--        </div>-->

        <!--        <div v-else class="course-direction-bigData">-->
        <!--            <header>-->
        <!--                <course-direction-pay :directionId=directionId />-->
        <!--            </header>-->

        <!--            <div class="bigData2"></div>-->
        <!--            <div class="bigData3"></div>-->
        <!--            <div class="bigData4"></div>-->
        <!--        </div>-->


        <div v-if="isPhone" class="course-direction-bigData-mobile">
            <div>
                <course-direction-pay class="<course-direction-pay-phone" :directionId='directionId'/>
            </div>

            <div>
                <div><img src="../../assets/img/big-data/课程介绍_02.jpg" style="height:100%;width: 100%;" alt=""></div>
                <!--什么是大数据-->
                <section class="what-bigdata-container">
                    <transition appear name="what-is-web-left">
                        <div class="section-title-box">
                            <div class="section-title">what?什么是大数据？</div>
                        </div>
                    </transition>

                    <div class="what-bigdata-desc-container">
                        <!--                        飞入动画-->
                        <transition appear name="what-is-web-left">
                            <img src="../../assets/img/big-data/picture_03.png" alt="图片" class="left-img">
                        </transition>

                        <transition appear name="what-is-web-right">
                            <div class="what-bigdata-desc">
                                <div class="what-bigdata-desc-title">大数据简介</div>
                                <p class="what-bigdata-desc-content">
                                    <span>大数据</span>是需要新处理模式才能具有更强的决策力、洞察发现力和流程优化能力来适应海量、高增长率和多样化的信息资产。</p>
                            </div>
                        </transition>

                        <div class="float-clear"></div>
                    </div>
                    <!--<div class="border-bottom"></div>-->
                </section>

                <!--大数据未来发展趋势-->
                <section class="bigdata-future-container">
                    <transition appear name="what-is-web-right">
                        <div class="section-title-box">
                            <div class="section-title">
                                大数据的未来发展趋势？
                            </div>
                        </div>
                    </transition>
                    <ul class="bigdata-future-desc-list">
                        <!--                        飞入动画-->
                        <transition appear name="what-is-web-left">
                            <li>
                                <p>
                                    <span>我国大数据</span>人才供不应求未来3到5年，人才需求呈直线式增长，数据分析师、数据架构师、大数据开发工程师等人才缺口更是达<span>百万级别</span>。
                                </p>
                            </li>
                        </transition>
                        <transition appear name="what-is-web-right">
                            <li>
                                <p>
                                    <span>马云</span>说：未来的时代将不是IT时代，而DT(Data Technology)的时代，最大的能源是<span>数据！</span>
                                </p>
                            </li>
                        </transition>

                        <transition appear name="what-is-web-left">
                            <li>
                                <p>
                                    经<span>李克强总理</span>签批，国务院印发<span>《促进大数据发展行动纲要》！</span>
                                </p>
                            </li>
                        </transition>


                        <div class="float-clear"></div>
                    </ul>
                    <!--<div class="img-box">-->
                    <!--                    <img [@openCloseLeft]="height800?'open':'close'" src="assets/imgs/introduce/industrial-scale.png">-->
                    <!--                    <img [@openCloseRight]="height1100?'open':'close'" src="assets/imgs/introduce/job-requirements.png">-->
                    <img src="../../assets/img/big-data/left_03.png" alt="图片">
                    <img src="../../assets/img/big-data/right_03.png" alt="图片">
                    <!--</div>-->
                    <p class="remark">根据官方网络数据显示，大数据职位薪资待遇在逐年上升<span>约11.38%!</span></p>
                </section>

                <section class="tledu-advantage">
                    <div class="section-title-box">
                        <!--                        动画-->
                        <div class="section-title">
                            为什么选择天亮教育？
                        </div>
                    </div>
                    <ul class="tledu-three-advantage">
                        <li>
                            <!--                            <img src="/assets/imgs/introduce/class-desc-img.jpg" alt="">-->
                            <img src="../../assets/img/big-data/课程介绍_07.jpg" alt="图片">
                            <p class="boxtitle">精品小班</p>
                            <p class="boxcontent">
                                天亮教育在班级招生上，实行精品小班，每个班级招生人数限制，保证引好路、打好基础，学习时间、进度把控更灵活，遇到任何问题均可以得到高效解决。精品小班更易于交流、提高学习效率，让学员学的更扎实。</p>
                        </li>

                        <li>
                            <!--                            <img src="/assets/imgs/introduce/teaching-desc-img.jpg" alt="">-->
                            <img src="../../assets/img/big-data/课程介绍_05.jpg" alt="图片">
                            <p class="boxtitle">全程面授</p>
                            <p class="boxcontent">
                                天亮教育所有课程采用全程面授模式，保证0基础、基础弱的同学可以100%不掉队，
                                面授讲师均为一线互联网公司工程师、工作经验4年起，并有充分的授课经验，
                                能够及时发现学员的各项细节问题，给予及时的指正和帮助，
                                不抛弃不放弃力争让所有学员能够学有所成、学以致用，全为为学员求职就业保驾护航。
                            </p>
                        </li>

                        <li>
                            <!--                            <img src="/assets/imgs/introduce/bigdata-desc-img.jpg" alt="">-->
                            <img src="../../assets/img/big-data/课程介绍_06.jpg" alt="图片">
                            <p class="boxtitle">开源共享</p>
                            <p class="boxcontent">
                                天亮教育技术开源共享，先后活跃国内众多优秀的QQ技术群，汲取新鲜技术营养，并帮助众多群友解决实际问题，吸引了众多小伙伴，参与到开源共享队伍中来。并且先后成立网络爬虫、nlp群(320349384，国内最大最优秀的数据采集群）、天亮教育(318971238)
                                、hadoop & spark & hive(297585251)，群友数近3000人，技术交流互通有无的过程中，迅速提升个人技能。</p>
                        </li>
                    </ul>
                    <p class="remark">
                        精细的课程，完整的教学体系，让学员学的放心，找到高薪工作！</p>
                </section>
            </div>

        </div>

        <div v-else class="course-direction-bigData-pc">
            <!--            <div>    <course-direction-pay :directionId=directionId />    </div>-->

            <div>
                <div><img src="../../assets/img/big-data/课程介绍_02.jpg" style="height:100%;width: 100%;" alt=""></div>
                <div class="content">
                    <div style="width: 1200px;margin: 0 auto;position: relative;padding-top: 1px">
                        <transition appear name="what-is-web-left">
                            <div>
                                <course-direction-pay :directionId="directionId"/>
                                <p
                                        style="font-size: 42px;color: #1ec5ef;margin-top: 30px;margin-left: 40px;letter-spacing:6px;margin-bottom: 0;">
                                    what?什么是大数据？</p>
                                <div style="width: 453px;background-color: #e3d240;height: 2px;margin-top: 10px;margin-left: 40px;"></div>
                            </div>
                        </transition>

                        <p
                                style="position: absolute;font-size: 92px;color: #1ec5ef;opacity: 0.04;top: 70px;right: 170px;letter-spacing:6px">
                            BIG&nbsp;DATA</p>
                        <!--                        飞入动画-->
                        <transition name="what-is-web-left">
                            <img v-if="leftImg" src="../../assets/img/big-data/picture_03.png" alt="图片"
                                 style="position: absolute;width: 350px;top: 150px;left: 70px;height: 320px;opacity: 0.8;">
                        </transition>

                        <transition name=" what-is-web-right">
                            <div v-if="leftImg" style="position: relative">
                                <img src="../../assets/img/big-data/border.png" alt=""
                                     style="position: absolute;width: 640px;top: -80px;right: 80px;height: 400px;">
                                <p style="font-size: 36px;color: #1ec5ef;margin-top:114px;margin-left: 690px;letter-spacing:6px">
                                    大数据简介</p>
                                <p
                                        style="width: 423px;font-size: 20px;color: #1ec5ef;margin-top: 10px;margin-left: 575px;letter-spacing:6px;text-align:justify; text-justify:inter-ideograph;">
                                    <span style="color: #e3d240;font-size: 26px">大数据</span>是需要新处理模式才能具有更强的决策力、洞察发现力和流程优化能力来适应海量、高增长率和多样化的信息资产。
                                </p>
                            </div>
                        </transition>
                        <div
                                style="width: 1100px;height: 3px;background-color: #009688;margin-top: 115px;margin-left: 45px;border-radius: 1px;"></div>
                        <transition name=" what-is-web-right">
                            <p v-if="leftImg"
                               style="font-size: 42px;color: #1ec5ef;margin-top: 30px;margin-left: 637px;letter-spacing:6px">
                                大数据的未来发展趋势？</p>
                        </transition>
                        <div style="width: 510px;background-color: #e3d240;height: 2px;margin-top: 10px;margin-left: 632px;"></div>
                        <p
                                style="position: absolute;font-size: 92px;color: #1ec5ef;opacity: 0.04;top: 565px;left: 46px;letter-spacing:6px">
                            FUTURE&nbsp;TREND</p>
                        <div style="position: absolute;width: 428px;height: 272px;border: 2px solid #1ec5ef;top: 670px;left: 50px"></div>
                        <p
                                style="position: absolute;width: 370px;font-size: 24px;top: 685px;left: 80px;color:#009688;letter-spacing:6px;text-align:justify; text-justify:inter-ideograph; ">
        <span
                style="color: #e3d240;font-size: 28px">我国大数据</span>人才供不应求未来3到5年，人才需求呈直线式增长，数据分析师、数据架构师、大数据开发工程师等人才缺口更是达<span
                                style="color: #e3d240;font-size: 28px">百万级别</span>。</p>
                        <div style="position: absolute;width: 614px;height: 116px;border: 2px solid #1ec5ef;top: 670px;left: 528px"></div>
                        <p
                                style="position: absolute;width: 570px;font-size: 20px;top: 692px;left: 556px;color:#009688;letter-spacing:6px;text-align:justify; text-justify:inter-ideograph; ">
                            <span style="color: #1dc3ec;">马云</span>说：未来的时代将不是IT时代，而DT(Data Technology)的时代，最大的能源是<span
                                style="color: #f7278f;font-size: 30px">数据！</span></p>
                        <div style="position: absolute;width: 614px;height: 116px;border: 2px solid #1ec5ef;top: 826px;left: 528px"></div>
                        <p
                                style="position: absolute;width: 570px;font-size: 20px;top: 842px;left: 556px;color:#009688;letter-spacing:6px;text-align:justify; text-justify:inter-ideograph; ">
                            经<span style="color: #1dc3ec;">李克强总理</span>签批，国务院印发<span
                                style="color: #f7278f;font-size: 26px">《促进大数据发展行动纲要》！</span></p>
                        <div style="position: absolute;width: 1093px;height: 383px;border: 2px solid #1ec5ef;top: 982px;left: 50px"></div>
                        <img src="../../assets/img/big-data/left_03.png" alt="图片"
                             style="position: absolute;width: 480px;top: 1040px;left: 80px;">
                        <img src="../../assets/img/big-data/right_03.png" alt="图片"
                             style="position: absolute;width: 517px;top: 1040px;right: 80px;">
                        <p style="font-size: 18px;color: #e3d240;text-align: center;margin-top: 750px">
                            根据官方网络数据显示，大数据职位薪资待遇在逐年上升<span
                                style="font-size: 24px;color: #f7278f">约11.38%!</span></p>
                        <p style="position: absolute;font-size: 72px;color: #009688;opacity: 0.04;top:1410px;left: 100px;">
                            THREE
                            CHARACTERISTICS</p>
                        <p style="font-size: 42px;color: #1ec5ef;letter-spacing:6px;text-align: center;margin-top: 28px;margin-bottom: 0;">
                            天亮教育大数据培训的三大特点</p>
                        <div style="background-color: #e3d240;width: 670px;height: 2px;margin: 10px auto;"></div>
                        <div class="threebox">
                            <div class="leftbox">
                                <img src="../../assets/img/big-data/课程介绍_07.jpg" alt="图片">
                                <p class="boxtitle">精品小班</p>
                                <p class="boxcontent">
                                    天亮教育在班级招生上，实行精品小班，每个班级招生人数限制，保证引好路、打好基础，学习时间、进度把控更灵活，遇到任何问题均可以得到高效解决。精品小班更易于交流、提高学习效率，让学员学的更扎实。
                                </p>
                            </div>

                            <div class="middlebox">
                                <img src="../../assets/img/big-data/课程介绍_05.jpg" alt="图片">
                                <p class="boxtitle">全程面授</p>
                                <p class="boxcontent">
                                    天亮教育所有课程采用全程面授模式，保证0基础、基础弱的同学可以100%不掉队，
                                    面授讲师均为一线互联网公司工程师、工作经验4年起，并有充分的授课经验，
                                    能够及时发现学员的各项细节问题，给予及时的指正和帮助，
                                    不抛弃不放弃力争让所有学员能够学有所成、学以致用，全为为学员求职就业保驾护航。
                                </p>
                            </div>

                            <div class="middlebox">
                                <img src="../../assets/img/big-data/课程介绍_06.jpg" alt="图片">
                                <p class="boxtitle">开源共享</p>
                                <p class="boxcontent">
                                    天亮教育技术开源共享，先后活跃国内众多优秀的QQ技术群，汲取新鲜技术营养，并帮助众多群友解决实际问题，吸引了众多小伙伴，参与到开源共享队伍中来。并且先后成立网络爬虫、nlp群(320349384，国内最大最优秀的数据采集群）、天亮教育(318971238)
                                    、hadoop & spark & hive(297585251)，群友数近3000人，技术交流互通有无的过程中，迅速提升个人技能。
                                </p>
                            </div>
                        </div>
                        <p style="font-size: 26px;color: #cc81fc;text-align: center;margin-top: 20px;margin-bottom: 0;">
                            精细的课程，完整的教学体系，让学员学的放心，找到高薪工作！</p>
                        <button type="button" class="button"><span style="font-size: 22px;color: #1ec5ef"
                                                                   @click="toTiangLiang">查看课程大纲</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {learningDirectionDetail} from "@api/courseDirection-api"
    import {showError, showSuccessMsg} from "@utils/msg";
    import CourseDirectionPay from "@components/courseDirection/CourseDirectionPay"
    import common from "../../mixin/common";

    export default {
        name: "PayCourseDirection",
        components: {
            CourseDirectionPay
        },
        mixins: [common],
        data() {
            return {
                isPhone: false,
                directionId: "",
                learningDirection: {},
                //控制左侧图片动画
                leftImg: false,
                //控制web优势入场动画
                advantage: false,
                //web前景就业
                webFuture: false,
                // 监听滚动
                scroll: "",
            }
        },
        created() {
            if (this.isMobile) {
                this.isPhone = true
            }

            this.directionId = this.$route.query.directionId
            learningDirectionDetail(this.directionId).then((res) => {
                if (res.code === 0) {
                    if (res.canStudyDirection) {
                        //    跳转到学院专属课程详情
                        // this.$message.success("您已购买该方向课程，快开始学习吧！");
                    } else {
                        //    跳转到返回的url
                        showSuccessMsg("您未购买该方向课程，先来了解下课程体系吧！");
                        this.learningDirection = res.learningDirection
                    }
                } else {
                    showError("获取学习方向出错", res.msg)
                }
            })
        },
        methods: {
            toTiangLiang() {
                window.open("http://myhope365.com/course/index")
            },
            handleScroll() {
                this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
                if (this.scroll > 0) {
                    this.leftImg = true
                }
                if (this.scroll > 400) {
                    this.webFuture = true
                }
                if (this.scroll > 1370) {
                    this.advantage = true
                }
            }

        },
        mounted() {
            //    监听滚轮事件
            window.addEventListener('scroll', this.handleScroll)
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll)
        },
    }
</script>

<style scoped lang="less">
    @import "../../styles/direction";
    /*.course-direction-bigData {*/
    /*    position: relative;*/
    /*    width: 100%;*/
    /*    background-color: white;*/


    /*    button {*/
    /*        width: 220px;*/
    /*        height: 56px;*/
    /*        font-size: 22px;*/
    /*        !*background: #FF632A*!*/
    /*    }*/

    /*    img {*/
    /*        display: block;*/
    /*    }*/

    /*    header {*/
    /*        height: 480px;*/
    /*        background: #000D47 url("../../assets/img/bigDataHeader.png") center no-repeat;*/
    /*        !*background-color: #000D47;*!*/
    /*    }*/

    /*    .bigData2 {*/
    /*        height: 678px;*/
    /*        background: url("../../assets/img/bigData2.jpg") center no-repeat;*/
    /*    }*/

    /*    .bigData3 {*/
    /*        height: 706px;*/
    /*        background: url("../../assets/img/bigData3.png") center no-repeat;*/
    /*    }*/

    /*    .bigData4 {*/
    /*        height: 1258px;*/
    /*        background: url("../../assets/img/bigData4.png") center no-repeat;*/
    /*    }*/
    /*}*/

    /*.mobile {*/
    /*    div {*/
    /*        width: 100%;*/

    /*        img {*/
    /*            width: 100%;*/
    /*            !*width: 200px;*!*/
    /*        }*/
    /*    }*/
    /*}*/

    .course-direction-pay-phone {
        position: absolute;
        bottom: 0px;
        left: 0px;
    }


    /*.phone {*/
    /*    display: none;*/
    /*}*/

    /*.paid {*/
    /*    display: block;*/
    /*}*/

    /*响应式*/
    @import '../../styles/variable.less';

    @media screen and (max-width: @screen-lg) {
        .phone {
            display: block;
        }

        .paid {
            display: none;
        }
    }

    /**************（（（（（（（（（（（（（（（（*））））））））））））***************************/
    /*定位*/
    /deep/ .to-pay {
        top: -140px;
    }

    .course-direction-bigData-mobile {
        /*[nz-carousel-content] {*/
        /*    margin-top: 0;*/
        /*    text-align: center;*/
        /*    color: #fff;*/
        /*    overflow: hidden;*/
        /*}*/
        width: 100%;
        background-color: #101029;
        padding-bottom: 50px;
        margin-top: 0;
        /*text-align: center;*/
        color: #fff;
        overflow: hidden;

        .body {
            background-color: #101029;
        }

        .top-img-title-box {
            background-color: #101029;
        }

        // 每个章节的标题
        .section-title-box {
            margin: 1rem 0.625rem 0 0.625rem;
            // 章节标题通用样式
            .section-title {
                font-size: 1.4rem;
                color: #1ec5ef;
                letter-spacing: 0.25rem;
                margin-bottom: 0;
                display: inline;
                padding-bottom: 0.5rem;
                border-bottom: 0.125rem solid #e3d240;

                p {
                    width: 100%;
                    text-align: center;
                }
            }
        }

        // 备注文字
        .remark {
            font-size: 0.8rem;
            color: #e3d240;
            text-align: center;
            padding: 10px;

            span {
                color: #f7278f;
                font-size: 1.1rem
            }
        }

        // 什么是大数据
        .what-bigdata-container {

            .what-bigdata-desc-container {
                position: relative;
                height: 168px;

                .left-img {
                    position: absolute;
                    width: 35%;
                    height: 80%;
                    top: 2rem;
                    left: 0.75rem;
                    opacity: 0.8;
                }

                // 什么是大数据详情
                .what-bigdata-desc {
                    float: right;
                    width: 65%;
                    background-size: 100% 100%;
                    padding: 0 2rem;

                    .what-bigdata-desc-title {
                        font-size: 1.4rem;
                        color: #1ec5ef;
                        letter-spacing: 0.25rem;
                        margin-top: 2rem;
                    }

                    .what-bigdata-desc-content {
                        width: 100%;
                        font-size: 0.8rem;
                        color: #1ec5ef;
                        letter-spacing: 0.25rem;
                        text-align: justify;
                        text-justify: inter-ideograph;

                        span {
                            font-size: 1rem;
                            color: #e3d240;
                        }
                    }
                }
            }
        }

        // 大数据未来的发展
        .bigdata-future-container {
            margin-top: 2rem;

            .section-title-box {
                text-align: right;
            }

            .bigdata-future-desc-list {
                width: 100%;
                margin-top: 1.25rem;
                padding: 0 0.75rem;

                li {
                    border: 0.125rem solid #1ec5ef;
                    width: 85%;
                    padding: 0.3rem;
                    margin-top: 0.7rem;

                    p {
                        font-size: 0.75rem;
                        color: #009688;
                        letter-spacing: 0.25rem;
                        text-align: justify;
                        text-justify: inter-ideograph;
                        margin: 0;
                        text-indent: 1.5rem;

                        span {
                            color: #e3d240;
                            font-size: 1rem
                        }
                    }
                }

                li:first-child {
                    margin-top: 0;
                }

                li:nth-of-type(odd) {
                    float: left;
                }

                li:nth-of-type(even) {
                    float: right;
                }


            }

            img {
                width: 100%;
                padding: 1rem;
            }

            .img-box {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        }

        // 天亮教育的优势
        .tledu-advantage {
            margin-top: 2rem;

            .section-title-box {
                text-align: center;
            }

            .tledu-three-advantage {
                display: flex;
                position: relative;
                flex-direction: column;
                margin-top: 1.25rem;

                li {
                    margin-top: 0.75rem;

                    img {
                        width: 90%;
                        margin: 0 0 0 5%;
                    }

                    .boxtitle {
                        font-size: 1.25rem;
                        line-height: 3rem;
                        margin: 0;
                        text-align: center;
                        color: white;
                    }

                    .boxcontent {
                        font-size: 0.8rem;
                        letter-spacing: 0.1rem;
                        line-height: 1.25rem;
                        width: 90%;
                        margin: 0 0 0 5%;
                        text-align: justify;
                        text-justify: inter-ideograph;
                        color: white;
                        text-indent: 1.5rem;
                    }
                }

                li:first-child {
                    margin-top: 0;
                }
            }

            .remark {
                margin-bottom: 0;
                padding-bottom: 1.25rem;
                color: #cc81fc;
                font-size: 1rem;
            }
        }

        .banner {
            width: 100%;
        }

    }

    /*PC端*/
    .course-direction-bigData-pc {

        /*.nz-carousel-content {*/
        /*    margin-top: 0;*/
        /*    text-align: center;*/
        /*    color: #fff;*/
        /*    overflow: hidden;*/
        /*}*/

        .button {
            width: 220px;
            height: 52px;
            border-radius: 16px;
            background-color: #101029;
            border: 1px solid #1ec5ef;
            margin-left: 490px;
            margin-top: 20px;
        }

        .button:hover {
            cursor: pointer;
        }

        .headerbox {
            width: 1200px;
            height: 80px;
            //background-color: green;
            margin: 0 auto
        }

        .logo {
            height: 50px;
            margin-top: 20px;
            float: left;
        }

        .headertext {
            font-size: 20px;
            float: left;
            margin-left: 25px;
            margin-top: 28px;
            line-height: 31px;
            border-bottom: 1px solid #333
        }

        .headerimg {
            float: right;
            margin-top: 30px;
            height: 20px;
            margin-right: 10px;
        }

        .navbox {
            width: 1200px;
            height: 40px;
            margin: 0 auto;
            //background-color: red;
        }

        .navfirst {
            float: left;
            width: 240px;
            height: 40px;
            background-color: #009688;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }

        .navlist {
            float: left;
            height: 40px;
            list-style: none;
            margin-left: 80px;
            margin-bottom: 0;
        }

        .navlist li {
            width: 132px;
            line-height: 40px;
            text-align: center;
            float: left;
            font-size: 16px;
            color: white;

            a {
                color: rgba(0, 0, 0, 0.65);
                color: white;
            }
        }

        .navlist li:hover {
            color: #009688;
            cursor: pointer;

            a {
                color: #009688;
            }
        }

        .navlist1 {
            line-height: 40px;
            text-align: center;
            color: white;
            font-size: 16px
        }

        .navlist1:hover {
            cursor: pointer;
        }

        .bottombox {
            height: 250px;
            background-color: #101029;
            border-top: 1px solid #1d1d3d;
        }

        .bottom1 {
            width: 1200px;
            height: 200px;
            margin: 0 auto;
        }

        .bottomlist1 {
            float: left;
            margin-left: 80px;
            list-style: none;
            margin-top: 30px;
            //background-color: red;
        }

        .bottomlist1 li {
            font-size: 14px;
            margin-top: 16px;
            color: white;
        }

        .bottomlist1 li:hover {
            cursor: pointer;
            color: #ff9800;
        }

        .bottombox1 {
            float: left;
            margin-top: 50px;
            margin-left: 50px;
            width: 1px;
            height: 68px;
            background-color: white;
        }

        .bottomlist2 {
            float: left;
            margin-left: 50px;
            list-style: none;
            margin-top: 30px;
            //background-color: red;
            padding: 0;

            a {
                color: white;
            }
        }

        .bottomlist2 li {
            font-size: 14px;
            margin-top: 16px;
            color: white;
        }

        .bottomlist2 li:hover {
            cursor: pointer;
            color: #ff9800;

            a {
                cursor: pointer;
                color: #ff9800;
            }
        }

        .bottomimgbox {
            width: 126px;
            height: 160px;
            float: right;
            margin-top: 50px;
            margin-right: 80px;
            //background-color: red;
        }

        .bottomimg {
            display: block;
            margin: 0 auto;
        }

        .bottomtext {
            color: white;
            margin-top: 10px;
            text-align: center;
        }


        .banner {
            width: 100%;
        }

        .content {
            width: 100%;
            height: 2200px;
            padding-top: 100px;
            background-color: #101029;
        }

        .threebox {
            width: 1200px;
            height: 364px;
            margin: 40px auto 0;
        }

        .leftbox {
            width: 380px;
            height: 362px;
            border: 1px solid #666;
            float: left;
        }

        .boxtitle {
            font-size: 18px;
            line-height: 54px;
            margin: 0;
            text-align: center;
            color: white;
        }

        .boxcontent {
            font-size: 12px;
            line-height: 20px;
            width: 340px;
            margin-left: 20px;
            text-align: justify;
            text-justify: inter-ideograph;
            color: white;
        }

        .middlebox {
            width: 380px;
            height: 362px;
            border: 1px solid #666;
            float: left;
            margin-left: 30px;
        }


        .body {
            background-color: #101029;
        }

        .introduce-container {
            width: 1200px;
            margin: 0 auto;
            background-color: #101029;
        }

        .what-bigdata-container {
            .section-title-box {
                .section-title {
                    font-size: 42px;
                    color: #1ec5ef;
                    margin-top: 30px;
                    margin-left: 40px;
                    letter-spacing: 6px;
                    margin-bottom: 0;
                }
            }
        }

    }

</style>
